import { differenceInSeconds } from 'date-fns';
import { EMPTY_NULL_DATA } from './constant';
import moment from 'moment';

export const convertHexToRGB = (hex) => {
  // check if it's a rgba
  if (hex.match('rgba')) {
    let triplet = hex.slice(5).split(',').slice(0, -1).join(',');
    return triplet;
  }

  let c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('');
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = '0x' + c.join('');

    return [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',');
  }
};

export function getTimeDifference(date) {
  let difference = differenceInSeconds(new Date(), date);

  if (difference < 60) return `${Math.floor(difference)} sec`;
  else if (difference < 3600) return `${Math.floor(difference / 60)} min`;
  else if (difference < 86400) return `${Math.floor(difference / 3660)} h`;
  else if (difference < 86400 * 30) return `${Math.floor(difference / 86400)} d`;
  else if (difference < 86400 * 30 * 12) return `${Math.floor(difference / 86400 / 30)} mon`;
  else return `${(difference / 86400 / 30 / 12).toFixed(1)} y`;
}

export const toCapitalCase = (str) => {
  return str?.charAt(0).toUpperCase() + str?.slice(1);
};

export const stringReplace = (str, toStr, withStr) => {
  return str?.replace(toStr, withStr);
};

export const makeDateUs = (dateString) => {
  const date = new Date(dateString);
  const options = { month: 'long', day: 'numeric', year: 'numeric' };
  const formattedDate = date.toLocaleDateString(undefined, options);
  return formattedDate;
};

export const renderItemDataOrEmptyNull = (text) => {
  if (text) {
    if (typeof text === 'number') {
      return numberWithCommas(text);
    } else {
      return text;
    }
  } else {
    if (text === 0) {
      return 0;
    } else {
      return EMPTY_NULL_DATA;
    }
  }
};

export function numberWithCommas(value) {
  if (value === 'NaN' || Number.isNaN(value) || value === '' || value === undefined) {
    return '';
  } else {
    return value.toFixed(2).toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
  }
}

export function getTimeInFormat(dateString) {
  const date = new Date(dateString);
  const options = { hour: '2-digit', minute: '2-digit', hour12: true };
  return date.toLocaleTimeString(undefined, options);
}

export const formatDate = (dateInput, format = 'DD-MM-YYYY') => {
  const date = moment(dateInput); // Current date and time
  const formattedDate = date.format(format); // Format the date as YYYY-MM-DD
  return formattedDate;
};

export const onChangeCustomDebounce = (
  delay = 2000,
  setCheck = 'Set Bolean state',
  value = 'Here you need to pass value of the onChange like e.target.value',
  state = 'Your state value which you have settld like setState(e.target.value)'
) => {
  setTimeout(() => {
    setCheck(true);
  }, delay);
  if (state?.length > value?.length) {
    setCheck(false);
  }
  if (state.length + 1 === value.length) {
    setCheck(false);
  }
  // Note:
  // Use this check settled by
  // setCheck state/check === true
  // then call the function using it to as dependency.
};

export const calculateRelativeTime = (timestamp) => {
  const currentTime = new Date();
  const messageTime = new Date(timestamp);
  const difference = currentTime - messageTime;
  let relativeTime;

  if (difference < 60000) {
    relativeTime = 'just now';
  } else if (difference < 3600000) {
    const minutes = Math.floor(difference / 60000);
    relativeTime = `${minutes} ${minutes === 1 ? 'minute' : 'minutes'} ago`;
  } else if (difference < 86400000) {
    const hours = Math.floor(difference / 3600000);
    relativeTime = `${hours} ${hours === 1 ? 'hour' : 'hours'} ago`;
  } else {
    const days = Math.floor(difference / 86400000);
    relativeTime = `${days} ${days === 1 ? 'day' : 'days'} ago`;
  }

  return relativeTime;
};

export function creditCardIcon(brand) {
  let iconComponent;

  switch (brand?.toLowerCase()) {
    case 'visa':
      iconComponent = <img src='/assets/visa.svg' alt='Visa card' style={{ height: '65px', width: '75px' }} />;
      break;
    case 'mastercard':
      iconComponent = <img src='/assets/mastercard.svg' alt='Mastercard' style={{ height: '65px', width: '75px' }} />;
      break;
    case 'american express':
    case 'amex':
      iconComponent = <img src='/assets/amex.svg' alt='American Express' style={{ height: '65px', width: '75px' }} />;
      break;
    case 'discover':
      iconComponent = <img src='/assets/discover.svg' alt='Discover card' style={{ height: '65px', width: '75px' }} />;
      break;
    // case 'diners club':
    // case 'dinersclub':
    //   iconComponent = <FaCcDinersClub />;
    //   break;
    // case 'jcb':
    //   iconComponent = <FaCcJcb />;
    //   break;
    case 'unionpay':
      iconComponent = <img src='/assets/unionpay.svg' alt='UnionPay card' style={{ height: '65px', width: '75px' }} />;
      break;
    // Add cases for other card brands as needed

    default:
      iconComponent = '';
  }

  return iconComponent;
};

export const timeZoneList = [
  { "value": "-1", "label": "-- Select a Timezone --" },
  { "value": "59", "label": "(GMT-01:00) Azores" },
  { "value": "60", "label": "(GMT-01:00) Cape Verde Is." },
  { "value": "61", "label": "(GMT-02:00) Mid-Atlantic" },
  { "value": "62", "label": "(GMT-03:00) Brasilia" },
  { "value": "63", "label": "(GMT-03:00) Buenos Aires" },
  { "value": "64", "label": "(GMT-03:00) Georgetown" },
  { "value": "65", "label": "(GMT-03:00) Greenland" },
  { "value": "66", "label": "(GMT-03:00) Montevideo" },
  { "value": "67", "label": "(GMT-03:30) Newfoundland" },
  { "value": "68", "label": "(GMT-04:00) Atlantic Time (Canada) Halifax, Bermuda" },
  { "value": "69", "label": "(GMT-04:00) La Paz" },
  { "value": "70", "label": "(GMT-04:00) Manaus" },
  { "value": "71", "label": "(GMT-04:00) Santiago" },
  { "value": "72", "label": "(GMT-04:30) Caracas" },
  { "value": "73", "label": "(GMT-05:00) Bogota, Lima, Quito, Rio Branco" },
  { "value": "74", "label": "(GMT-05:00) Eastern Time (US & Canada) Montreal, Toronto" },
  { "value": "75", "label": "(GMT-05:00) Indiana (East)" },
  { "value": "76", "label": "(GMT-06:00) Central America" },
  { "value": "77", "label": "(GMT-06:00) Central Time (US & Canada)" },
  { "value": "78", "label": "(GMT-06:00) Guadalajara, Mexico City, Monterrey" },
  { "value": "79", "label": "(GMT-06:00) Saskatchewan" },
  { "value": "80", "label": "(GMT-07:00) Arizona" },
  { "value": "81", "label": "(GMT-07:00) Chihuahua, La Paz, Mazatlan" },
  { "value": "82", "label": "(GMT-07:00) Mountain Time (US & Canada)" },
  { "value": "83", "label": "(GMT-08:00) Pacific Time (US & Canada)" },
  { "value": "84", "label": "(GMT-08:00) Tijuana, Baja California" },
  { "value": "85", "label": "(GMT-09:00) Alaska" },
  { "value": "86", "label": "(GMT-10:00) Hawaii" },
  { "value": "87", "label": "(GMT-11:00) Midway Island, Samoa" },
  { "value": "88", "label": "(GMT-12:00) International Date Line West" },
  { "value": "1", "label": "(GMT) Casablanca" },
  { "value": "2", "label": "(GMT) Greenwich Mean Time: Dublin, Edinburgh, Lisbon, London" },
  { "value": "3", "label": "(GMT) Monrovia, Reykjavik" },
  { "value": "4", "label": "(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna" },
  { "value": "5", "label": "(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague" },
  { "value": "6", "label": "(GMT+01:00) Brussels, Copenhagen, Madrid, Paris" },
  { "value": "7", "label": "(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb" },
  { "value": "8", "label": "(GMT+01:00) West Central Africa" },
  { "value": "9", "label": "(GMT+02:00) Amman" },
  { "value": "10", "label": "(GMT+02:00) Athens, Bucharest, Istanbul" },
  { "value": "11", "label": "(GMT+02:00) Beirut" },
  { "value": "12", "label": "(GMT+02:00) Cairo" },
  { "value": "13", "label": "(GMT+02:00) Harare, Pretoria" },
  { "value": "14", "label": "(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius" },
  { "value": "15", "label": "(GMT+02:00) Jerusalem" },
  { "value": "16", "label": "(GMT+02:00) Minsk" },
  { "value": "17", "label": "(GMT+02:00) Windhoek" },
  { "value": "18", "label": "(GMT+03:00) Baghdad" },
  { "value": "19", "label": "(GMT+03:00) Kuwait, Riyadh" },
  { "value": "20", "label": "(GMT+03:00) Moscow, St. Petersburg, Volgograd" },
  { "value": "21", "label": "(GMT+03:00) Nairobi" },
  { "value": "22", "label": "(GMT+03:00) Tbilisi" },
  { "value": "23", "label": "(GMT+03:30) Tehran" },
  { "value": "24", "label": "(GMT+04:00) Abu Dhabi, Muscat" },
  { "value": "25", "label": "(GMT+04:00) Baku" },
  { "value": "26", "label": "(GMT+04:00) Port Louis" },
  { "value": "27", "label": "(GMT+04:00) Yerevan" },
  { "value": "28", "label": "(GMT+04:30) Kabul" },
  { "value": "29", "label": "(GMT+05:00) Ekaterinburg" },
  { "value": "30", "label": "(GMT+05:00) Islamabad, Karachi" },
  { "value": "31", "label": "(GMT+05:00) Tashkent" },
  { "value": "32", "label": "(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi" },
  { "value": "33", "label": "(GMT+05:30) Sri Jayewardenepura" },
  { "value": "34", "label": "(GMT+05:45) Kathmandu" },
  { "value": "35", "label": "(GMT+06:00) Almaty, Novosibirsk" },
  { "value": "36", "label": "(GMT+06:00) Astana, Dhaka" },
  { "value": "37", "label": "(GMT+06:30) Yangon (Rangoon)" },
  { "value": "38", "label": "(GMT+07:00) Bangkok, Hanoi, Jakarta" },
  { "value": "39", "label": "(GMT+07:00) Krasnoyarsk" },
  { "value": "40", "label": "(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi" },
  { "value": "41", "label": "(GMT+08:00) Irkutsk, Ulaanbataar" },
  { "value": "42", "label": "(GMT+08:00) Kuala Lumpur, Singapore" },
  { "value": "43", "label": "(GMT+08:00) Perth" },
  { "value": "44", "label": "(GMT+08:00) Taipei" },
  { "value": "45", "label": "(GMT+09:00) Osaka, Sapporo, Tokyo" },
  { "value": "46", "label": "(GMT+09:00) Seoul" },
  { "value": "47", "label": "(GMT+09:00) Yakutsk" },
  { "value": "48", "label": "(GMT+09:30) Adelaide" },
  { "value": "49", "label": "(GMT+09:30) Darwin" },
  { "value": "50", "label": "(GMT+10:00) Brisbane" },
  { "value": "51", "label": "(GMT+10:00) Canberra, Melbourne, Sydney" },
  { "value": "52", "label": "(GMT+10:00) Guam, Port Moresby" },
  { "value": "53", "label": "(GMT+10:00) Hobart" },
  { "value": "54", "label": "(GMT+10:00) Vladivostok" },
  { "value": "55", "label": "(GMT+11:00) Magadan, Solomon Is., New Caledonia" },
  { "value": "56", "label": "(GMT+12:00) Auckland, Wellington" },
  { "value": "57", "label": "(GMT+12:00) Fiji, Kamchatka, Marshall Is." },
  { "value": "58", "label": "(GMT+13:00) Nuku'alofa" }
];

export function capitalizeFirstLetter(str) {
  return str && typeof(str) === 'string' ? str.charAt(0).toUpperCase() + str.slice(1) : str;
}
// export const formatPhoneNumber = (phoneNumber) => {
//   return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
//     3,
//     6
//   )}-${phoneNumber.slice(6)}`;
// };
export const formatPhoneNumber = (value) => {
  const phone = value == null ? '' : String(value);
  const cleaned = ('' + value).replace(/\D/g, '');
  if (phone.includes('+') && !cleaned.startsWith('1')) return phone;
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    const intlCode = (match[1] ? '+1 ' : '');
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  }
  return phone;
};
export function generatePromoCode(length) {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let code = '';

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    code += characters.charAt(randomIndex);
  }

  return code;
};


export const randomColors = [
  '#63B598', '#CE7D78', '#EA9E70', '#A48A9E', '#C6E1E8', '#648177', '#0D5AC1',
  '#F205E6', '#1C0365', '#14A9AD', '#4CA2F9', '#A4E43F', '#D298E2', '#6119D0',
  '#D2737D', '#C0A43C', '#F2510E', '#651BE6', '#61DA5E', '#CD2F00', '#9348AF',
  '#01AC53', '#C5A4FB', '#996635', '#B11573', '#4BB473', '#75D89E', '#2F3F94',
  '#2F7B99', '#DA967D', '#34891F', '#B0D87B', '#CA4751', '#7E50A8', '#C4D647',
  '#E0EEB8', '#11DEC1', '#289812', '#566CA0', '#FFDBE1', '#2F1179', '#935B6D',
  '#916988', '#513D98', '#AEAD3A', '#9E6D71', '#4B5BDC', '#0CD36D', '#250662',
  '#CB5BEA', '#228916', '#AC3E1B', '#DF514A', '#539397', '#880977', '#F697C1',
  '#BA96CE', '#679C9D', '#C6C42C', '#5D2C52', '#48B41B', '#E1CF3B', '#5BE4F0',
  '#57C4D8', '#A4D17A', '#225b8', '#BE608B', '#96B00C', '#088BAF', '#F158BF',
  '#E145BA', '#EE91E3', '#05D371', '#5426E0', '#4834D0', '#802234', '#6749E8',
  '#0971F0', '#8FB413', '#B2B4F0', '#C3C89D', '#C9A941', '#41D158', '#FB21A3',
  '#51AED9', '#5BB32D', '#21538E', '#89D534', '#D36647', '#7FB411', '#0023B8',
  '#3B8C2A', '#986B53', '#F50422', '#983F7A', '#EA24A3', '#79352C', '#521250',
  '#C79ED2', '#D6DD92', '#E33E52', '#B2BE57', '#FA06EC', '#1BB699', '#6B2E5F',
  '#64820F', '#1c271', '#9CB64A', '#996C48', '#9AB9B7', '#06E052', '#E3A481',
  '#0EB621', '#FC458E', '#B2DB15', '#AA226D', '#792ED8', '#73872A', '#520D3A',
  '#CEFCB8', '#A5B3D9', '#7D1D85', '#C4FD57', '#F1AE16', '#8FE22A', '#EF6E3C',
  '#243EEB', '#1dc18', '#DD93FD', '#3F8473', '#E7DBCE', '#421F79', '#7A3D93',
  '#635F6D', '#93F2D7', '#9B5C2A', '#15B9EE', '#0F5997', '#409188', '#911E20',
  '#1350CE', '#10E5B1', '#FFF4D7', '#CB2582', '#CE00BE', '#32D5D6', '#17232',
  '#608572', '#C79BC2', '#00F87C', '#77772A', '#6995BA', '#FC6B57', '#F07815',
  '#8FD883', '#060E27', '#96E591', '#21D52E', '#D00043', '#B47162', '#1EC227',
  '#4F0F6F', '#1D1D58', '#947002', '#BDE052', '#E08C56', '#28FCFD', '#bb09b',
  '#36486A', '#D02E29', '#1AE6DB', '#3E464C', '#A84A8F', '#911E7E', '#3F16D9',
  '#0F525F', '#AC7C0A', '#B4C086', '#C9D730', '#30CC49', '#3D6751', '#FB4C03',
  '#640FC1', '#62C03E', '#D3493A', '#88AA0B', '#406DF9', '#615AF0', '#4be47',
  '#2A3434', '#4A543F', '#79BCA0', '#A8B8D4', '#00EFD4', '#7AD236', '#7260D8',
  '#1DEAA7', '#06F43A', '#823C59', '#E3D94C', '#DC1C06', '#F53B2A', '#B46238',
  '#2DFFF6', '#A82B89', '#1A8011', '#436A9F', '#1A806A', '#4CF09D', '#C188A2',
  '#67EB4B', '#B308D3', '#FC7E41', '#AF3101', '#ff065', '#71B1F4', '#A2F8A5',
  '#E23DD0', '#D3486D', '#00F7F9', '#474893', '#3CEC35', '#1C65CB', '#5D1D0C',
  '#2D7D2A', '#FF3420', '#5CDD87', '#A259A4', '#E4AC44', '#1BEDE6', '#8798A4',
  '#D7790F', '#B2C24F', '#DE73C2', '#D70A9C', '#25b67', '#88E9B8', '#C2B0E2',
  '#86E98F', '#AE90E2', '#1A806B', '#436A9E', '#0EC0FF', '#F812B3', '#B17FC9',
  '#8D6C2F', '#D3277A', '#2CA1AE', '#9685EB', '#8A96C6', '#DBA2E6', '#76FC1B',
  '#608FA4', '#20F6BA', '#07D7F6', '#DCE77A', '#77ECCA'
];

export const getRandomColor = () => {
  return randomColors[Math.floor(Math.random() * randomColors.length)];
};

export function convertFromISO(isoString) {
  return isoString?.replaceAll('T', ' ')?.replaceAll('Z', ' ')?.trim();
}
export function combineDateAndTime(date, time) {
  // Split the time string into hours and minutes
  const [hours, minutes] = time.split(":").map(Number);

  // Create a new Date object from the date
  const combinedDateTime = new Date(date);

  // Set the hours and minutes
  combinedDateTime.setHours(hours, minutes, 0, 0); // setting seconds and milliseconds to 0

  return combinedDateTime;
}
